import './App.css';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from 'react-router-dom'
import DashboardPage from './pages/Dashboard';
import ChatPage from './pages/Chat';
import LandingPage from './pages/Landing';
import BuilderPage from './pages/Builder'
import LoginPage from './pages/Login';
import SignupPage from './pages/SignUp';
import { ProtectedRoute } from './components/ProtectedRoute';
import BuilderFlow from './pages/Builder/BuilderFlow';

function App() {
  return (
    <Router>
      <Routes>
        <Route path='/login' element={<LoginPage />} />
        <Route path='/signup' element={<SignupPage />} />
        <Route path='/landing' element={<LandingPage />} />

        {/* Protected Routes */}
        <Route path='/dashboard' element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } />
        <Route path='/chat' element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } />
        <Route path='/chat/:id' element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        } />
        <Route path='/builder/*' element={
          <ProtectedRoute>
            <BuilderFlow />
          </ProtectedRoute>
        } />

        {/* Redirect root to dashboard */}
        <Route path='/' element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } />

        {/* Fallback route - redirects all unmatched routes to login */}
        <Route path='*' element={<Navigate to='/login' replace />} />
      </Routes>
    </Router >
  );
}

export default App;
